import React, { useEffect, useState } from "react";
import {
  List,
  Card,
  Input,
  Space,
  message,
  Button,
  Row,
  Col,
  Tag,
  Typography,
} from "antd";
import Axios from "axios";
import { apiRoutes, environment } from "../../auth/apiRoute";
import { CloseOutlined, CloseCircleTwoTone } from "@ant-design/icons";

const { Search } = Input;
const { Text, Title } = Typography;
const gutterLayout = { xs: 8, sm: 16, md: 24, lg: 32 };
Array.prototype.unique = function () {
  var a = this.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1);
    }
  }

  return a;
};
export default function SelectHotel(props) {
  const [loading, setLoading] = useState(false);
  const [myHotelsData, setMyHotelsData] = useState([]);
  const [selectedHotels, setSelectedHotels] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    getHotelsData();
  }, []);
  useEffect(() => {
    getMyHotels();
  }, [data]);

  const getHotelsData = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].hotels);

      if (response.status == 200) {
        setData(response.data);
        setFilteredData(response.data);

        console.log(response.data.slice(0, 5));
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const getMyHotels = async () => {
    const myHotels = data.filter((item) => {
      if (item.admin) {
        return item.admin._id == props.user.id;
      }
    });

    setMyHotelsData(myHotels);
    const myHotelsIds = myHotels.map((item) => item._id);
    setSelectedHotels(myHotelsIds);
    // console.log(myHotelsIds);
  };
  const onChange = (e) => {
    const value = e.target.value.toLowerCase();
    console.log(value);
    if (!value) {
      setFilteredData(data);
    } else if (value.length > 4) {
      var filters = data.filter((item) => {
        return item.name.toLowerCase().includes(value);
      });
      console.log(filters);
      setFilteredData([...filters]);
    }
  };

  const onSearch = (value) => {
    if (!value) {
      setFilteredData(data);
    } else if (value.length > 4) {
      var filters = data.filter((item) => {
        return item.name.toLowerCase().includes(value);
      });
      console.log(filters);
      setFilteredData([...filters]);
    }
  };
  const onSelectHotel = (e) => {
    var hotelId = e.currentTarget.id;
    var hotel = data.find((item) => item._id == hotelId);

    if (hotel.suspended) {
      console.log("hotel is suspended");
      return;
    }

    if (hotel.admin && hotel.admin._id != props.user.id) {
      console.log("hotel is already claimed");
      return;
    }
    console.log(e.currentTarget);
    var newHotels = selectedHotels;
    if (newHotels.includes(hotelId)) {
      newHotels = newHotels.filter(function (item) {
        return item !== hotelId;
      });
    } else if (selectedHotels.length >= 3) {
      return;
    } else {
      newHotels.push(e.currentTarget.id);
    }

    setSelectedHotels([...newHotels]);
    console.log(selectedHotels);
  };
  const onConfirm = () => {
    if (selectedHotels.length == 0) {
      message.info(
        "You have to select at least one hotel to start nominations."
      );
      updateUserHotels({ hotels: selectedHotels, user: props.user });
    }

    if (selectedHotels.length > 0) {
      var userSelectedHotels = [];
      // selectedHotels.forEach((seclectedHotel) => {
      //   var hotel = data.find((item) => item._id == seclectedHotel);
      //   userSelectedHotels.push(hotel);
      // });

      updateUserHotels({ hotels: selectedHotels, user: props.user });
      // props.updateUser();
      // props.setCurrentStep();
    }
  };
  const updateUserHotels = async (values) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].hotelAdmin,
        values
      );
      message.success({
        content: "Great, start your nominations! ",
        className: "messageBox",
      });
      setLoading(false);
      setTimeout(() => {
        props.setCurrentStep();
      }, 1500);
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };

  const isHoverable = (item) => {
    var hoverable = true;
    if (item.suspended) {
      hoverable = false;
      return hoverable;
    }
    if (item.admin) {
      hoverable = false;
    }
    if (item.admin && item.admin._id == props.user.id) {
      hoverable = true;
    }
    if (selectedHotels.length >= 3) {
      hoverable = false;
    }
    if (selectedHotels.length >= 3 && selectedHotels.includes(item._id)) {
      hoverable = true;
    }
    return hoverable;
  };
  return (
    <div style={{ width: "100%" }}>
      <Text>
        Please select at least one hotel to start nominations. You can select up
        to 3 hotels.
      </Text>
      <Search
        placeholder="search hotel by name"
        onSearch={onSearch}
        onChange={onChange}
        enterButton
      />
      <Space />
      <List
        grid={{
          gutter: 8,
          xs: 1,
          sm: 2,
          md: 3,
          lg: 3,
          xl: 3,
          xxl: 4,
        }}
        dataSource={filteredData
          .slice(0, 9)
          .concat(myHotelsData)
          .unique()
          .reverse()}
        renderItem={(item) => (
          <List.Item>
            <Card
              headStyle={{
                backgroundColor: !item.suspended ? "aliceblue" : "white",
              }}
              type={"inner"}
              size="default"
              key={item._id}
              id={item._id}
              loading={loading}
              hoverable={isHoverable(item)}
              title={item.name}
              className={
                selectedHotels.includes(item._id) ? "selected-card " : ""
              }
              onClick={onSelectHotel}
            >
              {item.suspended ? (
                <>
                  <Tag icon={<CloseOutlined />} color="error">
                    suspended
                  </Tag>
                </>
              ) : (
                <></>
              )}
              {item.admin ? (
                <Tag color="default">
                  Claimed by {item.admin.firstName} {item.admin.lastName}
                </Tag>
              ) : (
                <></>
              )}
              <br />
              {item.street} <br />
              {item.city}, {item.state}
            </Card>
          </List.Item>
        )}
      />
      <Space />
      <Row gutter={gutterLayout}>
        <Col span={12}>
          <Button
            type="primary"
            disabled={loading ? true : false}
            htmlType="submit"
            onClick={props.goPrevious}
            block
          >
            Previous
          </Button>
        </Col>{" "}
        <Col span={12}>
          <Button
            type="primary"
            disabled={loading ? true : false}
            htmlType="submit"
            onClick={onConfirm}
            block
          >
            Confirm
          </Button>
        </Col>
      </Row>
    </div>
  );
}
